import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import Aws from '../shared/configs/aws';
import Sentry from '../shared/configs/sentry';
import Amplitude from '../shared/configs/amplitude';
import LocalStorage from '../shared/services/LocalStorage';

import '../shared/index.css';

Sentry.configure();
Aws.configureAmplify({
  authStorage: LocalStorage.getInstance(),
});
Amplitude.configure();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
